import { createSiteScrollBlocker } from './createSiteScrollBlocker'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { FeatureExportsSymbol } from '@wix/thunderbolt-symbols'
import { IFeatureExportsStore } from 'thunderbolt-feature-exports'
import { name } from './index'
import { ISiteScrollBlocker } from '@wix/site-scroll-blocker-service'
import { getSiteScrollBlockerConfig } from './siteScrollBlockerConfig'

const siteScrollBlockerFactory = (siteScrollBlockerExports: IFeatureExportsStore<typeof name>): ISiteScrollBlocker => {
	const config = getSiteScrollBlockerConfig(siteScrollBlockerExports)
	const scrollBlocker = createSiteScrollBlocker(config)

	siteScrollBlockerExports.export({
		setSiteScrollingBlocked: scrollBlocker.setSiteScrollingBlocked,
		isScrollingBlocked: scrollBlocker.isScrollingBlocked(),
	})

	return scrollBlocker
}

export const SiteScrollBlocker = withDependencies([named(FeatureExportsSymbol, name)], siteScrollBlockerFactory)
